"use client";
import { jsxs as n, jsx as d } from "react/jsx-runtime";
import { forwardRef as t, useId as a } from "react";
import { styled as m } from "@mui/material";
const s = m("svg", {
  name: "ForgeSvgIcon",
  slot: "Root"
})({
  fill: "currentColor",
  verticalAlign: "middle",
  display: "inline-block",
  transition: "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  flexShrink: 0
}), h = t(
  ({ children: i, titleAccess: o, ...e }, l) => {
    const r = `svgId-${a()}`;
    return /* @__PURE__ */ n(
      s,
      {
        ref: l,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        width: "1em",
        height: "1em",
        role: o ? "img" : "presentation",
        focusable: o ? "true" : "false",
        "aria-hidden": o ? "false" : "true",
        "aria-labelledby": o ? r : void 0,
        ...e,
        children: [
          o && /* @__PURE__ */ d("title", { id: r, children: o }),
          i
        ]
      }
    );
  }
);
export {
  h as default
};
